<template>
  <div class="details">
    <form-title>基本信息</form-title>
    <info-panel :padding="24">
      <el-row>
        <el-col :span="col">
          <info-item label="课程名称">
            {{ result.courseName }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="课程类型">
            {{ result.courseCategoryName }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="课程简介">
            {{ result.courseSimpleIntro }}
          </info-item>
        </el-col>
      </el-row>
    </info-panel>
    <div class="flex">
      <el-button-group class="switch-btns">
        <el-button
          :type="switchBtnKey === 'live'?'primary':'default'"
          @click="switchBtnHandler('live')"
        >
          直播课程
        </el-button>
        <el-button
          :type="switchBtnKey === 'preJob' ?'primary':'default'"
          @click="switchBtnHandler('preJob')"
        >
          岗前培训
        </el-button>
      </el-button-group>
    </div>
    <form-title>课程信息</form-title>
    <info-panel :padding="24">
      <el-row>
        <el-col :span="col">
          <info-item label="主讲老师">
            {{ result[switchBtnKey].mainTeacherUserRealName }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="状态">
            <status :props="result[switchBtnKey].valid">
              {{ result[switchBtnKey].valid === types.COURSE_ENABLE ? '上架' : '下架' }}
            </status>
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="课程方式">
            {{ courseTypeList.filter(v => v.value === result[switchBtnKey].courseType).map(v=>v.label).join() }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="考试类型">
            {{ examTypeList.filter(v => v.value === result[switchBtnKey].examType).map(v=>v.label).join() }}
          </info-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="col">
          <info-item
            label="课程价格"
          >
            {{ format(result[switchBtnKey].coursePrice) }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="老师列表">
            {{ result[switchBtnKey].teacherList.map(v => v.teacherUserRealName).join(',') }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="视频考试数量">
            {{ result[switchBtnKey].videoExamCount }}
            <el-tooltip
              effect="dark"
              content="-1代表按章节走"
              placement="top-start"
            >
              <i
                class="el-icon-question"
                style="margin-left:10px;"
              />
            </el-tooltip>
          </info-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="col">
          <info-item label="封面图">
            <el-image
              :src="result[switchBtnKey].courseCoverPic"
              :preview-src-list="[result[switchBtnKey].courseCoverPic]"
            />
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="小程序Icon">
            <el-image
              :src="result[switchBtnKey].mpIcon"
              :preview-src-list="[result[switchBtnKey].mpIcon]"
            />
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="小程序Icon选中状态">
            <el-image
              :src="result[switchBtnKey].mpIconClick"
              :preview-src-list="[result[switchBtnKey].mpIconClick]"
            />
          </info-item>
        </el-col>
      </el-row>
    </info-panel>
    <form-title>分销信息</form-title>
    <info-panel :padding="24">
      <el-row>
        <el-col :span="col">
          <info-item label="平台分销金额">
            {{ format(result[switchBtnKey].platformDistributionAmount) }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="机构分销金额">
            {{ format(result[switchBtnKey].agencyDistributionAmount) }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="平台代辅导金额">
            {{ format(result[switchBtnKey].counselingAmount) }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="视频审核金额">
            {{ format(result[switchBtnKey].videoReviewAmount) }}
          </info-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="col">
          <info-item label="老师分销金额">
            {{ format(result[switchBtnKey].teacherAmount) }}
          </info-item>
        </el-col>
      </el-row>
    </info-panel>
    <form-title>出题规则</form-title>
    <info-panel :padding="24">
      <el-row>
        <el-col :span="col">
          <info-item label="判断题个数">
            {{ format(result[switchBtnKey].judgmentCount,'count') }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="判断题分数">
            {{ format(result[switchBtnKey].judgmentScore,'score') }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="选择题个数">
            {{ format(result[switchBtnKey].choiceCount,'count') }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="选择题分数">
            {{ format(result[switchBtnKey].choiceScore,'score') }}
          </info-item>
        </el-col>
      </el-row>
    </info-panel>
    <form-title>备注信息</form-title>
    <info-panel :padding="24">
      <el-row>
        <el-col>
          <info-item label="备注信息">
            {{ result[switchBtnKey].remark }}
          </info-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <info-item
            label="证书编号"
          >
            {{ result[switchBtnKey].certNo }}
          </info-item>
        </el-col>
      </el-row>
    </info-panel>
    <form-title>课程章节</form-title>
    <info-panel>
      <el-tree
        :data="chapter"
        :props="treeProps"
      >
        <span
          slot-scope="{ node, data }"
          class="custom-tree-node"
        >
          <span class="name">{{ data.chapterName }}</span>
          <span class="line" />
          <span class="url">{{ data.videoUrl }}</span>
        </span>
        <el-tree />
      </el-tree>
    </info-panel>
  </div>
</template>
<script>
import infoPanel from '@/components/common/infoPanel.vue';
import infoItem from '@/components/common/infoItem.vue';
import formTitle from '@/components/common/formTitle.vue';
import axClient from '@/services';
import status from '@/components/common/status.vue';
import types, { courseTypeList, examTypeList } from '@/config';

export default {
  name: 'AccountDetails',
  components: {
    formTitle,
    infoPanel,
    infoItem,
    status,
  },
  data() {
    return {
      treeProps: {
        children: 'sonList',
        label: 'chapterName',
      },
      switchBtnKey: 'live',
      types,
      courseTypeList,
      examTypeList,
      col: 5,
      result: {
        live: {
          examType: '',
          courseType: '',
          teacherList: [],
        },
      },
      chapter: [],
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    // 详情
    async getInfo() {
      this.result = await axClient.course.getCourseDetail(this.$route.params.courseClassId);
      this.getChapter();
    },
    async getChapter() {
      this.chapter = await axClient.course.listChapter(this.result[this.switchBtnKey].id);
    },
    // 切换显示机构人员
    switchBtnHandler(val) {
      this.switchBtnKey = val;
      this.getChapter();
    },
    format(money, type) {
      if (!type) {
        return `${money ? money / 100 : money}元`;
      }
      if (type === 'count') {
        return `${money}个`;
      }
      if (type === 'score') {
        return `${money}分`;
      }
      return '';
    },
  },
};
</script>
<style lang="scss" scoped>
.details {
  .title {
    margin-top: 12px;
  }
  .custom-tree-node {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    font-size: 0;
    .name {
      font-size: 16px;
    }
    .url{
      padding-left: 15px;
      color: $--base-color-main;
      font-size: 14px;
    }
    .line {
      flex: 1;
      height: 1px;
      margin-left: 12px;
      background: rgba($--base-color-black, 0.2);
    }
  }
  .switch-btns {
    padding-top: 20px;
  }
}
</style>
